<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">

    <h2>Dettaglio Device Aziendale</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">
        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Device Id" readonly="true" />
        </mat-form-field>

        <!-- codiceCespite field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="codiceCespite" placeholder="Codice Cespite" />
          <mat-error *ngIf="form.get('codiceCespite').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- mac field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="mac" placeholder="Device mac"/>
          <mat-error *ngIf="form.get('mac').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- serie field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="serie" placeholder="Serie del Device"/>
          <mat-error *ngIf="form.get('serie').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- fattura field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="fattura" placeholder="fattura"/>
          <mat-error *ngIf="form.get('fattura').errors?.required">
            Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="form.get('fattura').errors?.pattern">
            Deve essere un numero
          </mat-error>
        </mat-form-field>
        
        <!-- dataConsegna field -->
        <mat-form-field fxlayout="column">
          <input matInput [matDatepicker]="consegna" formControlName="dataConsegna" placeholder="data di consegna"/>
          <mat-datepicker-toggle matSuffix [for]="consegna"></mat-datepicker-toggle>
          <mat-datepicker #consegna></mat-datepicker>
          <mat-error *ngIf="form.get('dataConsegna').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>
        
        <!-- dataRiconsegna field -->
        <mat-form-field fxlayout="column">
          <input matInput [matDatepicker]="riconsegna" formControlName="dataRiconsegna" placeholder="data di riconsegna"/>
          <mat-datepicker-toggle matSuffix [for]="riconsegna"></mat-datepicker-toggle>
          <mat-datepicker #riconsegna></mat-datepicker>
        </mat-form-field>
        
        <!-- formattato field -->
        <mat-slide-toggle formControlName="formattato" fxlayout="column">
          Formattato
        </mat-slide-toggle>

        <mat-form-field fxlayout="column">
        <mat-label>Tipologia Device</mat-label>
        
        <mat-select formControlName="tipoId" [compareWith]="compareSoftware">
          <mat-option *ngFor="let tipo of tipi" [value]="tipo">
            {{ tipo.descrizione }}
          </mat-option>
        </mat-select>
        
        </mat-form-field>

        <mat-form-field fxlayout="column">
          <mat-label>Collaboratore Device</mat-label>
          
          <mat-select formControlName="collaboratori" [compareWith]="compareSoftware">
            
            <mat-option [value]="null">--Vuoto--</mat-option>

            <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
              {{ collaboratore.userName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

         <!-- Software field -->
        <mat-selection-list formControlName="software" [compareWith]="compareSoftware">
          <mat-list-option *ngFor="let sw of listaSoftware" [value]="sw">
            {{ sw.descrizione }}
          </mat-list-option>
        </mat-selection-list>

      
        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">
            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm('/device')" color="primary">Back</button>
      <button mat-raised-button (click)="deviceSave()" [disabled]="form.invalid || !form.dirty"
        *ngIf="device?.deleteDate==null">Save</button>
      <button mat-raised-button (click)="deviceDelete()" [disabled]="device?.id==null"
        *ngIf="device?.deleteDate==null">Delete</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card> 